<template>
    <div>
        <sammio-actions mobileNavText="haku" @drawer="setDrawerStatus" :isMobile="getMobileStatus" :status="getDrawerStatus"></sammio-actions>

        <div class="container">
            <!--
            <div class="row">
                <div class="col-md-5 mx-auto mt-4 p-3 bg-white">
                    <v-skeleton-loader
                            class="mx-auto"
                            max-width="100%"
                            type="article@4"
                    ></v-skeleton-loader>
                </div>
            </div>
            -->
            <div class="row">
                <aside v-if="!getMobileStatus" class="col-md-4 col-md-4 bg-white p-0 pt-3" ref="sticky__wrapper"  id="sammio__element--aside">

                    <div ref="stickyContent" :class="!isIntersecting ? '' : 'v-sticky--element'">
                        <div :class="isIntersecting ? 'sammio__container--scrollable ' : '' " :style="isIntersecting ? 'width:'+ this.stickyWidth + 'px' : ''">
                            <sammio-search-filters></sammio-search-filters>

                        </div>
                    </div>
                </aside>
                <section :class="getClassNames" id="sammio__element--main">
                    <article ref="article" v-show="!hasErrors.hasErrors">
                        <div class="sammio__intersect--marker" v-intersect="onIntersect"></div>
                        <sammio-search-main></sammio-search-main>
                    </article>

                    <article v-if="hasErrors.hasErrors">
                        <sammio-errors
                                :data="this.$store.getters.getErrors.data"
                                target="search"
                        ></sammio-errors>
                    </article>
                </section>

            </div>
        </div>
        <v-navigation-drawer
                v-model="showMobileDrawer"
                app
                temporary
                width="90vw"
                v-if="getMobileStatus"
        >
            <v-btn class="btn-link border-0 p-0 m-0 text-black sammio__button--close_panel" @click="showMobileDrawer = false"><x-icon size="1.75x" ></x-icon><span class="sr-only">{{$t('sammio.close')}}</span></v-btn>
            <sammio-search-filters></sammio-search-filters>
        </v-navigation-drawer>
    </div>

</template>

<script>
    import SammioSearchFilters from './SammioSearchFilters.vue';
    import SammioSearchMain from './SammioSearchMain.vue';
    import SammioActions from "../SammioActions";
    import {XIcon} from 'vue-feather-icons'
    import SammioErrors from "../SammioErrors";
    import layout from "../../shared/layout-mixin";
    import {fetchSubsection, getInt} from "../../store/helpers";

    export default {
        name: "SammioSearch",
        components: {
            sammioSearchFilters: SammioSearchFilters,
            sammioSearchMain: SammioSearchMain,
            sammioActions: SammioActions,
            sammioErrors: SammioErrors,
            XIcon
        },
        mixins: [layout],
        created() {
            this.$store.dispatch('initFilters')
        },
        computed: {
            hasErrors () {
                return this.$store.getters.getErrors
            },
            searchResultsEmpty () {
                return this.$store.getters.getVisibleCards.length === 0
            }
        },
        methods: {
            getSubsectionCallback(payload) {
                this.$store.dispatch('addVisibleCard', payload)
            },
            updateSingleCardView() {
                const path = this.$router.currentRoute.path;
                let regexpPath = /\/(?<statuteIndex>\w+)\/(?<chapterIndex>\w+)\/(?<sectionIndex>\w+)\/?(?<subsectionIndex>\w+)/g
                let match = regexpPath.exec(path)
                if (match !== null) {
                    let cardIndices = {
                        statuteIndex: getInt(match.groups.statuteIndex),
                        chapterIndex: getInt(match.groups.chapterIndex),
                        sectionIndex: getInt(match.groups.sectionIndex),
                        subsectionIndex: match.groups.subsectionIndex ? getInt(match.groups.subsectionIndex) : 1
                    }
                    if (this.searchResultsEmpty) {
                        this.$store.dispatch('setSingleCardView', cardIndices)
                    } else {
                        fetchSubsection(this.$store, cardIndices, 0, this, this.getSubsectionCallback)
                    }
                } else {
                    this.$store.dispatch('clearSingleCardView')
                }
            }
        },
        mounted() {
            this.updateSingleCardView()
        },
        watch: {
            $route (to, from) {
                if ((to.name.startsWith('search') &&
                    from &&
                    ((from.name !== to.name) || (from.params !== to.params)))) { // coming from another view
                    this.updateSingleCardView()
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
